export const API_METADATA = {
  BASE_PATH: Symbol('api:basePath'),
  BASE_URL: Symbol('api:baseUrl'),
  ROUTES: Symbol('api:routes'),
  PARAMS: Symbol('api:params'),
  BODY: Symbol('api:body'),
  QUERY: Symbol('api:query'),
  RESPONSE_TYPE: Symbol('api:responseType'),
  LOG: Symbol('api:log'),
  HEADERS: Symbol('api:headers'),
  REPORT_PROGRESS: Symbol('api:reportProgress'),
};

